<template>
  <v-card max-width="100%" outlined>
    <v-toolbar dense color="red lighten-1">
      <v-toolbar-title class="white--text"> Funcionários</v-toolbar-title>
    </v-toolbar>
    <v-card-actions class="mt-1 mx-2 pb-0 mb-0 d-flex justify-end">
      <!-- <FormCreateEmployee /> -->
      <v-dialog v-model="dialog" max-width="1000" persistent>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="green lighten-1" dark small class="mb-2" v-bind="attrs" v-on="on">
            <v-icon>mdi-account-plus</v-icon>
          </v-btn>
        </template>
        <v-card class="pb-3">
          <v-app-bar dark dense color="red lighten-1" elevation="0">
            <v-toolbar-title>Cadastro de Funcionário</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon text>
              <v-icon>mdi-account-plus</v-icon>
            </v-btn>
          </v-app-bar>
          <v-card-text class="pb-0">
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pb-0 mb-0" color="red">
                  <v-alert text outlined class="py-2" color="deep-orange" icon="mdi-fire">
                    Todos os dados do formulário são obrigatórios!
                  </v-alert>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12" class="pb-0 mb-0" color="red">
                  <p class="font-weight-black mb-0 pb-0 subtitle-1 text-red">
                    Dados do Funcionário
                  </p>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4">
                  <v-text-field
                    v-model.trim="$v.form.name.$model"
                    :error-messages="errors.data.name"
                    type="text"
                    label="Nome"
                    outlined
                    dense
                    hide-details="auto"
                    @change="errorMensage('name')"
                    @blur="errorMensage('name')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.surname.$model"
                    type="text"
                    label="Sobrenome"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.surname"
                    @change="errorMensage('surname')"
                    @blur="errorMensage('surname')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.social_name.$model"
                    type="text"
                    label="Nome Social"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.social_name"
                    @change="errorMensage('social_name')"
                    @blur="errorMensage('social_name')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-select
                    v-model.trim="$v.form.gender.$model"
                    :items="gender"
                    item-value="id"
                    item-text="name"
                    label="Genero"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.gender"
                    @change="errorMensage('gender')"
                    @blur="errorMensage('gender')"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.birthdate.$model"
                    label="Data de Nascimento"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.birthdate"
                    @change="errorMensage('birthdate') | checkDate('birthdate')"
                    @blur="errorMensage('birthdate') | checkDate('birthdate')"
                    @keyup="checkDate('birthdate')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.cpf.$model"
                    v-mask="'###.###.###-##'"
                    type="text"
                    label="CPF"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.cpf"
                    @change="errorMensage('cpf')"
                    @blur="errorMensage('cpf')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.rg.$model"
                    type="number"
                    label="RG"
                    outlined
                    dense
                    class="m-0 p-0"
                    required
                    hide-details="auto"
                    :error-messages="errors.data.rg"
                    @change="errorMensage('rg')"
                    @blur="errorMensage('rg')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.email.$model"
                    label="E-mail"
                    type="email"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.email"
                    @change="errorMensage('email')"
                    @blur="errorMensage('email')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.mobile_phone.$model"
                    v-mask="'(##)#########'"
                    type="text"
                    label="Telefone"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.mobile_phone"
                    @change="errorMensage('mobile_phone')"
                    @blur="errorMensage('mobile_phone')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4" class="m-0 p-0">
                  <v-select
                    v-model.trim="$v.form.marital_status.$model"
                    :items="marital_status"
                    item-text="status"
                    item-value="id"
                    dense
                    label="Estado Civil"
                    outlined
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.marital_status"
                    @change="errorMensage('marital_status')"
                    @blur="errorMensage('marital_status')"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4" class="m-0 p-0">
                  <v-select
                    v-model.trim="$v.form.user_type.$model"
                    :items="user_types"
                    item-text="type"
                    item-value="id"
                    dense
                    label="Tipo de Usuário"
                    outlined
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.user_type"
                    @change="errorMensage('user_type')"
                    @blur="errorMensage('user_type')"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pb-0 mb-0" color="red">
                  <p class="font-weight-black mb-0 pb-0 subtitle-1 text-red">
                    Endereço do Funcionário
                  </p>
                </v-col>
                <v-col cols="12" sm="10" md="3" lg="5">
                  <v-text-field
                    v-model.trim="$v.form.street_name.$model"
                    label="Nome da Rua"
                    outlined
                    dense
                    hide-details="auto"
                    :error-messages="errors.data.street_name"
                    @change="errorMensage('street_name')"
                    @blur="errorMensage('street_name')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" md="3" lg="2" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.building_number.$model"
                    label="Número"
                    type="number"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.building_number"
                    @change="errorMensage('building_number')"
                    @blur="errorMensage('building_number')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.post_code.$model"
                    v-mask="'#####-###'"
                    label="CEP"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.post_code"
                    @change="errorMensage('post_code')"
                    @blur="errorMensage('post_code')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.complement.$model"
                    label="Complemento"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.complement"
                    @change="errorMensage('complement')"
                    @blur="errorMensage('complement')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-autocomplete
                    v-model.trim="$v.form.state.$model"
                    :items="states"
                    item-value="id"
                    item-text="name"
                    label="Estado"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.state"
                    @change="errorMensage('state') | getCities()"
                    @blur="errorMensage('state')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-autocomplete
                    v-if="cities != ''"
                    v-model.trim="$v.form.city.$model"
                    :items="cities"
                    item-value="id"
                    item-text="name"
                    label="Cidade"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.city"
                    @change="errorMensage('city')"
                    @blur="errorMensage('city')"
                  ></v-autocomplete>
                  <v-autocomplete
                    v-else
                    label="Cidade"
                    hide-details
                    outlined
                    dense
                    class="m-0 p-0"
                    disabled
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.neighborhood.$model"
                    label="Bairro"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.neighborhood"
                    @change="errorMensage('neighborhood')"
                    @blur="errorMensage('neighborhood')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    hide-details
                    label="País"
                    value="Brasil"
                    outlined
                    dense
                    class="m-0 p-0"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pb-0 mb-0" color="red">
                  <p class="font-weight-black mb-0 pb-0 subtitle-1 text-red">Dados da Empresa</p>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.employee_registration.$model"
                    type="number"
                    label="Matricula"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.employee_registration"
                    @change="errorMensage('employee_registration')"
                    @blur="errorMensage('employee_registration')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="3" class="m-0 p-0">
                  <v-autocomplete
                    v-model="form.workstation"
                    :items="workstations"
                    item-value="id"
                    item-text="workstation"
                    dense
                    hide-details
                    label="Lotação"
                    outlined
                    class="m-0 p-0"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="3" class="m-0 p-0">
                  <v-autocomplete
                    v-model.trim="$v.form.employee_department.$model"
                    :items="departments"
                    item-value="id"
                    item-text="department"
                    dense
                    label="Setor"
                    outlined
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.employee_department"
                    @change="errorMensage('employee_department')"
                    @blur="errorMensage('employee_department')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="3" class="m-0 p-0">
                  <v-autocomplete
                    v-model.trim="$v.form.employee_role.$model"
                    :items="roles"
                    item-value="id"
                    item-text="role"
                    dense
                    label="Cargo"
                    outlined
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.employee_role"
                    @change="errorMensage('employee_role')"
                    @blur="errorMensage('employee_role')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="3" class="m-0 p-0">
                  <v-autocomplete
                    v-model.trim="$v.form.employee_function.$model"
                    :items="functions"
                    item-value="id"
                    item-text="functions"
                    dense
                    label="Função"
                    outlined
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.employee_function"
                    @change="errorMensage('employee_function')"
                    @blur="errorMensage('employee_function')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.salary.$model"
                    label="Salário Base"
                    outlined
                    dense
                    type="number"
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.salary"
                    @change="errorMensage('salary')"
                    @blur="errorMensage('salary')"
                    @keyup="totalSalary()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model="form.dangerousness"
                    hide-details
                    type="number"
                    label="Periculosidade"
                    outlined
                    dense
                    class="m-0 p-0"
                    @keyup="totalSalary()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="form.gratification"
                    label="Gratificações"
                    outlined
                    dense
                    type="number"
                    class="m-0 p-0"
                    hide-details="auto"
                    @keyup="totalSalary()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="form.unhealthy"
                    type="number"
                    label="Insalubridade"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    @keyup="totalSalary()"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="total_salary"
                    label="Salário Total"
                    outlined
                    dense
                    readonly
                    class="m-0 p-0"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.admission_date.$model"
                    label="Data da Admissão"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.admission_date"
                    @change="errorMensage('admission_date') | checkDate('admission_date')"
                    @blur="errorMensage('admission_date') | checkDate('admission_date')"
                    @keyup="checkDate('admission_date')"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-4 py-0 my-0 d-flex justify-space-between">
            <v-btn color="dark darken-1" text @click="close">Sair</v-btn>
            <v-btn dark small color="blue darken-1" elevation="0" @click="storeEmployee"
              >Cadastrar Funcionário</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>

    <v-card-title class="pt-0">
      <v-text-field
        v-if="employees"
        v-model="Pesquisar"
        append-icon="mdi-magnify"
        label="Pesquisar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      v-if="employees"
      :headers="headers"
      :items="employees"
      sort-by="full_name"
      :search="Pesquisar"
      class="elevation-3"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          text
          medium
          icon
          link
          :to="{ name: 'details_employees', params: { employee_id: item.id } }"
        >
          <v-icon medium color="orange"> mdi-pencil </v-icon>
        </v-btn>
      </template>

      <template v-slot:[`item.mobile_phone`]="{ item }">
        <tr>
          {{
            '(' + item.mobile_phone.substr(0, 2) + ')' + item.mobile_phone.substr(2, 9)
          }}
        </tr>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <tr>
          {{
            item.status_name.toUpperCase()
          }}
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
export default {
  name: 'TableUser',
  directives: { mask },
  data: function () {
    return {
      Pesquisar: '',
      gender: [
        { id: 1, name: 'Masculino' },
        { id: 2, name: 'Feminino' },
      ],
      dialog: false,
      cities: [],
      total_salary: '',
      form: {
        name: '',
        surname: '',
        birthdate: '',
        cpf: '',
        rg: '',
        social_name: '',
        gender: '',
        email: '',
        mobile_phone: '',
        marital_status: '',
        street_name: '',
        building_number: '',
        post_code: '',
        complement: '',
        state: '',
        city: '',
        neighborhood: '',
        employee_registration: '',
        employee_department: '',
        employee_role: '',
        employee_function: '',
        admission_date: '',
        salary: '',
        gratification: '',
        dangerousness: '',
        unhealthy: '',
        workstation: '',
        user_type: '',
      },
      errors: {
        messages: {
          required: 'O campo e obrigatorio',
          minLength: (num) => `O campo deve ter no minimo ${num} caracteres`,
          email: 'Email invalido',
          maxLength: (num) => `O campo deve ter no maximo ${num} caracteres`,
        },
        data: {
          name: [],
          surname: [],
          birthdate: [],
          cpf: [],
          rg: [],
          social_name: [],
          gender: [],
          email: [],
          mobile_phone: [],
          marital_status: [],
          street_name: [],
          building_number: [],
          post_code: [],
          complement: [],
          state: [],
          city: [],
          neighborhood: [],
          employee_registration: [],
          employee_department: [],
          employee_role: [],
          employee_function: [],
          admission_date: [],
          salary: [],
          workstation: [],
          user_type: [],
        },
      },
      headers: [
        { text: 'Nome do Funcionário', align: 'start', sortable: false, value: 'full_name' },
        { text: 'Setor', value: 'department_name' },
        { text: 'Cargo', value: 'role_name' },
        { text: 'Função', value: 'function_name' },
        { text: 'Email', value: 'email' },
        { text: 'Telefone', value: 'mobile_phone' },
        { text: 'Status', sortable: true, value: 'status' },
        { text: 'Ações', value: 'actions', sortable: false },
      ],
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
      },
      surname: {
        required,
        minLength: minLength(4),
      },
      birthdate: {
        required,
      },
      cpf: {
        required,
        minLength: minLength(14),
        maxLength: maxLength(14),
      },
      rg: {
        required,
        minLength: minLength(6),
      },
      social_name: {
        required,
        minLength: minLength(3),
      },
      gender: {
        required,
      },
      email: {
        required,
        email,
      },
      mobile_phone: {
        required,
        minLength: minLength(13),
        maxLength: maxLength(13),
      },
      marital_status: {
        required,
      },
      street_name: {
        required,
      },
      building_number: {
        required,
      },
      post_code: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9),
      },
      complement: {},
      state: {
        required,
      },
      city: {
        required,
      },
      neighborhood: {
        required,
      },
      employee_registration: {
        required,
      },
      employee_department: {
        required,
      },
      employee_role: {
        required,
      },
      employee_function: {
        required,
      },
      admission_date: {},
      salary: {},
      workstation: {},
      user_type: { required },
    },
  },
  computed: {
    ...mapState('employees', ['employees']),
    ...mapState('utils', [
      'states',
      'marital_status',
      'departments',
      'functions',
      'roles',
      'workstations',
      'user_types',
    ]),
  },
  methods: {
    ...mapActions('employees', ['ActionStoreEmployee']),
    ...mapActions('ui', ['ActionSetLoading']),
    totalSalary: function () {
      let dangerous = this.form.dangerousness ? this.form.dangerousness : 0
      let baseSalary = this.form.salary ? this.form.salary : 0
      let gratifications = this.form.gratification ? this.form.gratification : 0
      let unhealthy = this.form.unhealthy ? this.form.unhealthy : 0
      this.total_salary = (
        parseFloat(dangerous) +
        parseFloat(baseSalary) +
        parseFloat(gratifications) +
        parseFloat(unhealthy)
      ).toFixed(2)
    },
    async storeEmployee() {
      this.ActionSetLoading(true)
      try {
        this.$v.$touch()
        Object.keys(this.errors.data).forEach((key) => {
          this.errorMensage(key)
        })
        if (!this.$v.$invalid) {
          let { birthdate, admission_date } = this.form
          birthdate = this.formatStringDataToSend(birthdate)
          admission_date = this.formatStringDataToSend(admission_date)
          await this.ActionStoreEmployee({ ...this.form, birthdate, admission_date })
          this.$swal({
            icon: 'success',
            title: 'Cadastrado',
            text: 'Usuario cadastrado com sucesso',
          })
          this.close()
        }
      } catch (error) {
        if (error.body) {
          if (error.status != 422) {
            this.$swal({
              icon: 'error',
              title: 'Erro',
              text: error.body.message,
            })
          }
          if (error.body.errors) {
            Object.keys(error.body.errors).map((key) => {
              this.errors.data[key] = error.body.errors[key]
            })
          }
        }
      }

      this.ActionSetLoading(false)
    },
    getCities: async function () {
      this.cities = await this.$http
        .get('dash/utils/cities/' + this.form.state)
        .then((response) => response.body.cities)
    },
    close() {
      this.dialog = false
    },
    errorMensage(key) {
      const errors = []
      if (key == 'id') return
      if (!this.$v.form[key].$dirty) return errors

      if (this.$v.form[key].required !== undefined)
        !this.$v.form[key].required && errors.push(this.errors.messages.required)

      if (this.$v.form[key].minLength !== undefined)
        !this.$v.form[key].minLength &&
          errors.push(this.errors.messages.minLength(this.$v.form[key].$params.minLength.min))

      if (this.$v.form[key].maxLength !== undefined)
        !this.$v.form[key].maxLength &&
          errors.push(this.errors.messages.maxLength(this.$v.form[key].$params.maxLength.max))

      if (this.$v.form[key].email !== undefined)
        !this.$v.form[key].email && errors.push(this.errors.messages.email)

      this.errors.data[key] = errors
    },
    checkDate(key) {
      let v = this.form[key]
      if (this.form[key].length == 2 || this.form[key].length == 5) {
        if (v.substring(v.length - 1, v.length - 1) !== '/') this.form[key] = this.form[key] + '/'
      } else if (this.form[key].length > 10) {
        this.form[key] = this.form[key] - 1
      }
      if (v.length > 10) {
        this.form[key] = v.substring(0, 9)
      } else if (v.length == 10) {
        const dateReg = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
        if (!this.form[key].match(dateReg)) {
          this.errors.data[key] = ['Data invalida']
        } else {
          this.errors.data[key] = []
        }
      }
    },
    formatStringDataToSend(data) {
      let dia = data.split('/')[0]
      let mes = data.split('/')[1]
      let ano = data.split('/')[2]
      return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2)
    },
  },
  watch: {
    dialog() {
      if (this.dialog == false) {
        Object.keys(this.form).map((key) => {
          this.form[key] = ''
        })
        this.total_salary = ''
        Object.keys(this.errors.data).map((key) => {
          this.errors.data[key] = []
        })
      }
    },
  },
}
</script>
